import { gql } from '@apollo/client';
import {
  UserFragment,
  ShopCartFragment,
  ClientFragment,
  OrderFragment,
  CompanyFragment,
  BenefitFragment,
  OrderBenefitFragment,
  AddressFragment,
} from './fragments';

// AUTH ------------------------------------------------
export const SIGN_IN = gql`
  mutation SIGN_IN($data: SignInInput!) {
    signIn(data: $data) {
      user {
        ...UserFragment
      }
      token
    }
  }
  ${UserFragment}
`;

export const SIGN_OUT = gql`
  mutation SIGN_OUT {
    signOut {
      success
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation RESET_PASSWORD($data: ResetPasswordInput) {
    resetPassword(data: $data) {
      success
      err
    }
  }
`;

export const CHANGE_PASSWORD_WITHOUT_TOKEN = gql`
  mutation CHANGE_PASSWORD_WITHOUT_TOKEN(
    $data: ChangePasswordWithoutTokenInput
  ) {
    changePasswordWithoutToken(data: $data) {
      success
      err
    }
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation CHANGE_PASSWORD($data: ChangePasswordInput) {
    changePassword(data: $data) {
      success
      err
    }
  }
`;

export const ADD_ITEM_TO_SHOP_CART = gql`
  mutation ADD_ITEM_TO_SHOP_CART($data: AddItemToShopCartInput!) {
    addItemToShopCart(data: $data) {
      ...ShopCartFragment
    }
  }
  ${ShopCartFragment}
`;

export const ADD_PAYMENT_TO_SHOPCART = gql`
  mutation AddPaymentToShopCart($data: AddPaymentToShopCartInput) {
    addPaymentToShopCart(data: $data) {
      _id
    }
  }
`;

export const REMOVE_ITEM_FROM_SHOP_CART = gql`
  mutation REMOVE_FROM_SHOP_CART($data: RemoveItemFromShopCartInput) {
    removeItemFromShopCart(data: $data) {
      ...ShopCartFragment
    }
  }
  ${ShopCartFragment}
`;

export const ADD_TO_WISHLIST = gql`
  mutation ADD_TO_WISHLIST($data: ClientWishlistInput!) {
    addToWishlist(data: $data) {
      ...ClientFragment
    }
  }
  ${ClientFragment}
`;

export const REMOVE_FROM_WISHLIST = gql`
  mutation REMOVE_FROM_WISHLIST($data: ClientWishlistInput!) {
    removeFromWishlist(data: $data) {
      ...ClientFragment
    }
  }
  ${ClientFragment}
`;

// ORDERS -----------------------------------------

export const CREATE_ORDER = gql`
  mutation CREATE_ORDER($data: CreateOrderInput) {
    createOrder(data: $data) {
      ...OrderFragment
    }
  }
  ${OrderFragment}
`;

export const CREATE_ORDER_WITH_STATUS_COMPLETE = gql`
  mutation CreateOrderWithStatusCompleted($data: CreateOrderInput) {
    createPaidOrder(data: $data) {
      _id
      status
      code
    }
  }
`;

export const CANCEL_ORDER = gql`
  mutation CANCEL_ORDER($data: CancelOrderInput) {
    cancelOrder(data: $data) {
      ...OrderFragment
    }
  }
  ${OrderFragment}
`;

export const REVIEW_ORDER = gql`
  mutation REVIEW_ORDER($data: ReviewOrderInput) {
    reviewOrder(data: $data) {
      ...OrderFragment
    }
  }
  ${OrderFragment}
`;

export const SIGN_S3 = gql`
  mutation SIGN_S3($data: SignS3Input!) {
    signS3(data: $data) {
      signedRequest
      url
    }
  }
`;

export const CREATE_BENEFIT_REQUEST = gql`
  mutation CreateBenefitRequest($data: CreateBenefitRequestInput) {
    createBenefitRequest(data: $data) {
      user {
        ...UserFragment
      }
      company {
        ...CompanyFragment
      }
      amountRequested
    }
  }
  ${UserFragment}
  ${CompanyFragment}
`;

export const SEND_ORDER_BENEFIT = gql`
  mutation SendOrderBenefit($data: SendOrderBenefitInput) {
    sendOrderBenefit(data: $data) {
      ...OrderBenefitFragment
    }
  }
  ${OrderBenefitFragment}
`;

export const UPDATE_USER = gql`
  mutation UPDATE_USER($data: UpdateUserInput) {
    updateUser(data: $data) {
      ...UserFragment
    }
  }
  ${UserFragment}
`;

export const CREATE_USER_ADDRESS = gql`
  mutation CREATE_USER_ADDRESS($data: CreateUserAddressInput) {
    createUserAddress(data: $data) {
      address {
        ...AddressFragment
      }
    }
  }
  ${AddressFragment}
`;

export const UPDATE_USER_ADDRESS = gql`
  mutation UPDATE_USER_ADDRESS($data: UpdateUserAddressInput) {
    updateUserAddress(data: $data) {
      address {
        ...AddressFragment
      }
    }
  }
  ${AddressFragment}
`;

// PAYMENT METHODS ----------------------------------------- TODO: Add to the schema

export const PAYMENT_BY_TDC = gql`
  mutation PaymentByTDC($data: PaymentTDCInput) {
    paymentByTDC(data: $data) {
      user
      amount
      _id
      paymentGatewayId
      success
      message
      reference
      paymentMethod {
        title
      }
    }
  }
`;

export const PAYMENT_BY_MOVILE = gql`
  mutation PaymentByMobile($data: PaymentMobileInput) {
    paymentByMobile(data: $data) {
      _payment {
        _id
        amount
        success
        message
      }
      remainingAmount
      paymentResult
    }
  }
`;
